module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_3009.1067ee90.png";